import React, { useCallback, useEffect } from 'react' 
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { newClientRedirect } from 'services/api'
import { Spinner } from '@chakra-ui/react'

enum statusCodeReferred{
  LIMIT_EXCEEDED = 400,
  NOT_EXIT = 404,
  EXPIRED = 409,
  ERROR = 500
}

const NewClient: React.FC = () => {
  const [searchParams] = useSearchParams()
  const token: string = searchParams.get('token')
  const { executeRecaptcha } = useGoogleReCaptcha()

  const handleReCaptchaVerify = useCallback(async (action: string) => {
    if (!executeRecaptcha) {
      console.info('Execute recaptcha not yet available')
      return ''
    }
    const token = await executeRecaptcha(action)
    return token
  }, [executeRecaptcha])

  
const newClient = async ()=>{
    const recaptchaToken: string = await handleReCaptchaVerify('referredValidate');
    newClientRedirect( token,recaptchaToken )
    setTimeout(()=>{
      window.location.replace(`${process.env.REACT_APP_ONB2_BASE_URL}/suscripcion/datos`)
    }, 100)
}

  useEffect(()=>{
    newClient()
  },[])
  
  return (
    <div>
        <Spinner variant='default' data-testid='spinner' />
    </div>
  )
}

export default NewClient
